import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';
import { headers as defaultHeaders } from './constants';
import Identity from './identity';

export interface SwgAccessTokenResponse {
  accessToken: string;
}

/** @hidden */
export function isSwgAccessTokenResponse(object: any): object is SwgAccessTokenResponse {
  return (<SwgAccessTokenResponse>object).accessToken !== undefined;
}

/**
 * This method calls Arc Identity to generate an access token for use with Subscribe with Google's swg.js when calling
 * `subscribe.saveSubscription`
 */
export const getSwgAccessToken = async (): Promise<APIErrorResponse | SwgAccessTokenResponse> => {
  const headers: { [index: string]: string } = { ...defaultHeaders };
  if (
    Identity.userIdentity &&
    Identity.userIdentity.accessToken &&
    Identity.userIdentity.refreshToken
  ) {
    await Identity.heartbeat();
    headers['Authorization'] = `Bearer ${Identity.userIdentity.accessToken}`;
  }
  return fetch(`${Identity.apiOrigin}/identity/public/v1/swg/accesstoken`, {
    method: 'GET',
    headers
  })
    .then(JSONResponseHandler)
    .then(response => {
      if (isSwgAccessTokenResponse(response)) {
        return response;
      } else {
        throw response;
      }
    });
};

export default getSwgAccessToken;
